<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Cities List</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" /></div>

                    <div class="col-sm-3">
                        <button type="button" class="btn btn-primary mb-4" (click)="loadCitiesList(0,perpage)"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadCitiesList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let city of citiesList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{city.name}}</td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="city.status=='1'">Active</span>
                                <span class="badge bg-azure-light" *ngIf="city.status=='0'">In-Active</span>
                            </td>


                            <!-- <td *ngIf="myrole=='1'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{user.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{user.id}}">
                                    <a class="dropdown-item" routerLink="/update-user/{{user.id}}"><i class="fa fa-pen"></i> Update</a>
                                    <a *ngIf="myrole=='1' && user.status!='2' && currentUserId!=user.id" class="dropdown-item" (click)="deleteUser(user.id)"><i class="fa fa-trash"></i> Delete User</a>
                                    <a *ngIf="myrole=='1'" class="dropdown-item" (click)="deleteUserSession(user.id)"><i class="fa fa-minus-circle"></i> Delete Session</a>
                                </div>
                             </div>
                        </td> -->
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !citiesList.length">
                            <td colspan="20"><i class="far fa-frown"></i> City not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>